import { api } from "@/api";
import { ActionContext } from "vuex";
import { WalletCreate, WalletUpdate } from "@/interfaces";
import { State } from "../state";
import { WalletState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import {
  commitSetWallets,
  commitSetWallet,
  commitSetCurrencies,
  commitSetPrices,
  commitSetWalletBalance,
} from "./mutations";
import { dispatchCheckApiError } from "../main/actions";
import {
  commitAddNotification,
  commitRemoveNotification,
} from "../main/mutations";

type WalletContext = ActionContext<WalletState, State>;

export const actions = {
  async actionGetWallets(context: WalletContext) {
    try {
      const response = await api.getWallets(
        context.rootState.main.token,
        false
      );
      if (response) {
        commitSetWallets(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetWalletsWithBalance(context: WalletContext) {
    try {
      const response = await api.getWallets(context.rootState.main.token, true);
      if (response) {
        commitSetWallets(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetWalletBalance(
    context: WalletContext,
    payload: { walletId: number }
  ) {
    try {
      const response = await api.getBalance(
        context.rootState.main.token,
        payload.walletId
      );
      if (response) {
        commitSetWalletBalance(context, {
          id: payload.walletId,
          balance: response.data,
        });
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetCurrencies(context: WalletContext) {
    try {
      const response = await api.getCurrencies();
      if (response) {
        commitSetCurrencies(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetPrices(context: WalletContext) {
    try {
      console.log("get prices");
      const response = await api.getPrices();
      console.log(response);
      if (response) {
        commitSetPrices(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  // async actionGetWithdrawStates(context: WalletContext) {
  //   try {
  //     const response = await api.getWithdrawStates();
  //     if (response) {
  //       commitSetWithdrawStates(context, response.data);
  //     }
  //   } catch (error) {
  //     await dispatchCheckApiError(context, error);
  //   }
  // },
  async actionUpdateWallet(
    context: WalletContext,
    payload: { id: number; wallet: WalletUpdate }
  ) {
    const loadingNotification = {
      content: "در حال ذخیره سازی کیف پول",
      showProgress: true,
    };
    try {
      commitAddNotification(context, loadingNotification);
      const response = (
        await Promise.all([
          api.updateWallet(
            context.rootState.main.token,
            payload.id,
            payload.wallet
          ),
          await new Promise((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetWallet(context, response.data);
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, {
        content: "کیف پول با موفقیت ویرایش شد",
        color: "success",
      });
    } catch (error) {
      const response = await dispatchCheckApiError(context, error);
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, {
        content: response,
        color: "error",
      });
    }
  },
  // async actionUpdateWithdraw(
  //   context: WalletContext,
  //   payload: { id: number; withdraw: WithdrawUpdate }
  // ) {
  //   const loadingNotification = {
  //     content: "در حال ذخیره سازی",
  //     showProgress: true,
  //   };
  //   try {
  //     commitAddNotification(context, loadingNotification);
  //     const response = (
  //       await Promise.all([
  //         api.updateWithdraw(
  //           context.rootState.main.token,
  //           payload.id,
  //           payload.withdraw
  //         ),
  //         await new Promise((resolve, reject) =>
  //           setTimeout(() => resolve(), 500)
  //         ),
  //       ])
  //     )[0];
  //     commitSetWithdraw(context, response.data);
  //     commitRemoveNotification(context, loadingNotification);
  //     commitAddNotification(context, {
  //       content: "درخواست برداشت با موفقیت ویرایش شد",
  //       color: "success",
  //     });
  //   } catch (error) {
  //     const response = await dispatchCheckApiError(context, error);
  //     commitRemoveNotification(context, loadingNotification);
  //     commitAddNotification(context, {
  //       content: response,
  //       color: "error",
  //     });
  //   }
  // },
  async actionCreateWallet(context: WalletContext, payload: WalletCreate) {
    const loadingNotification = {
      content: "در حال ذخیره سازی",
      showProgress: true,
    };
    try {
      commitAddNotification(context, loadingNotification);
      const response = (
        await Promise.all([
          api.createWallet(context.rootState.main.token, payload),
          await new Promise((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetWallet(context, response.data);
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, {
        content: "کیف پول با موفقیت ساخته شد",
        color: "success",
      });
    } catch (error) {
      const response = await dispatchCheckApiError(context, error);
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, {
        content: response,
        color: "error",
      });
    }
  },
  // async actionCreateWithdraw(context: WalletContext, payload: WithdrawCreate) {
  //   const loadingNotification = {
  //     content: "در حال ذخیره سازی",
  //     showProgress: true,
  //   };
  //   try {
  //     commitAddNotification(context, loadingNotification);
  //     const response = (
  //       await Promise.all([
  //         api.createWithdraw(context.rootState.main.token, payload),
  //         await new Promise((resolve, reject) =>
  //           setTimeout(() => resolve(), 500)
  //         ),
  //       ])
  //     )[0];
  //     commitSetWithdraw(context, response.data);
  //     commitRemoveNotification(context, loadingNotification);
  //     commitAddNotification(context, {
  //       content: "درخواست برداشت با موفقیت ثبت شد.",
  //       color: "success",
  //     });
  //   } catch (error) {
  //     const response = await dispatchCheckApiError(context, error);
  //     commitRemoveNotification(context, loadingNotification);
  //     commitAddNotification(context, {
  //       content: response,
  //       color: "error",
  //     });
  //   }
  // },
};

const { dispatch } = getStoreAccessors<WalletState, State>("");

export const dispatchCreateWallet = dispatch(actions.actionCreateWallet);
export const dispatchGetCurrencies = dispatch(actions.actionGetCurrencies);
export const dispatchGetPrices = dispatch(actions.actionGetPrices);
export const dispatchGetWallets = dispatch(actions.actionGetWallets);
export const dispatchGetWalletsWithBalance = dispatch(
  actions.actionGetWalletsWithBalance
);
export const dispatchUpdateWallet = dispatch(actions.actionUpdateWallet);
export const dispatchGetWalletBalance = dispatch(
  actions.actionGetWalletBalance
);
// export const dispatchUpdateWithdraw = dispatch(actions.actionUpdateWithdraw);
// export const dispatchCreateWithdraw = dispatch(actions.actionCreateWithdraw);
